<template>
    <div class="flex flex-col gap-4">
        <SliderRoot
            v-bind="$attrs"
            :model-value="modelValue"
            :max="max"
            :min="min"
            :step="step"
            class="relative flex items-center select-none touch-none w-full h-5"
            :aria-label="sliderLabel">
            <SliderTrack class="bg-slider-track relative grow rounded-full h-2">
                <SliderRange class="absolute bg-control-accent rounded-full h-full slider-range" />
            </SliderTrack>
            <SliderThumb class="block w-5 h-5 rounded-full bg-control-accent shadow-xs slider-thumb" :aria-valuetext="announcedAriaValueText" />
        </SliderRoot>
        <slot name="labels">
            <div v-if="labelStart || labelEnd" class="flex justify-between">
                <p v-if="labelStart" class="body-small text-control-label">{{ labelStart }}</p>
                <p v-if="labelEnd" class="body-small text-control-label">{{ labelEnd }}</p>
            </div>
        </slot>
    </div>
</template>

<script setup lang="ts">
import { invariant } from "~vue/utils";
import { SliderRange, SliderRoot, type SliderRootProps, SliderThumb, SliderTrack } from "reka-ui";
import { computed } from "vue";
const {
    max = 1,
    min = 0,
    step = 1,
    thumbValueLabel,
    modelValue,
} = defineProps<
    SliderRootProps & {
        // slider label for screen readers, required for accessibility
        sliderLabel: string;
        // optional array of labels for each thumb value, used for aria-valuetext. Length must match the number of steps in the slider
        thumbValueLabel?: string[];
        labelStart?: string;
        labelEnd?: string;
    }
>();

const currentStep = computed(() => (modelValue ?? [])[0] ?? 0);
const announcedAriaValueText = computed(() => thumbValueLabel?.[currentStep.value]);

if (thumbValueLabel) {
    invariant(thumbValueLabel.length === (max - min) / step + 1, "thumbValueLabel array length must match the number of steps in the slider");
}
</script>
